export const setFlujo = flujo => {
  sessionStorage.setItem('flujo', flujo)
}

export const getFlujo = () => {
  return sessionStorage.getItem('flujo') || 'autogestion'
}
